import { render, staticRenderFns } from "./DocumentCard.vue?vue&type=template&id=ae2dfc9e&scoped=true"
import script from "./DocumentCard.vue?vue&type=script&lang=js"
export * from "./DocumentCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae2dfc9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae2dfc9e')) {
      api.createRecord('ae2dfc9e', component.options)
    } else {
      api.reload('ae2dfc9e', component.options)
    }
    module.hot.accept("./DocumentCard.vue?vue&type=template&id=ae2dfc9e&scoped=true", function () {
      api.rerender('ae2dfc9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarship/cardHandling/components/DocumentCard.vue"
export default component.exports